/* Hallmark · component-flow: city battle bridge · genre: playful · theme: existing Worldly */
/* Hallmark · pre-emit critique: P5 H5 E4 S5 R5 V4 */

import { useEffect, useRef } from 'react';
import type { Tier } from '@geogame/shared';

import { useGame } from '../store/gameStore';

/** Backward-compatible entry for old /city/:tier links; city play now uses the battle engine. */
export function CityScreen({ tier }: { readonly tier: Tier }): React.JSX.Element {
  const startMatch = useGame((s) => s.startMatch);
  const started = useRef(false);

  useEffect(() => {
    if (started.current) return;
    started.current = true;
    startMatch({ mode: 'quick', gameMode: 'city', tier });
  }, [startMatch, tier]);

  return (
    <main className="gg-screen gg-center">
      <p className="gg-subtitle">Joining a Pin the City battle…</p>
    </main>
  );
}
